import { element } from 'prop-types';
import React, { Component } from 'react';
import { CURRENCY, FORMAT_NUMBER, SYMBOL } from '../libs/utils/Const';

class DeliverModal extends Component {

    //#region ########## CHANGE FIELDS DOC #############################################
    ChangeFolio = (value) => {
        const { newOrderModel, RefreshOrder } = this.props
        newOrderModel.U_FMB_FolioCounter = value;
        RefreshOrder(newOrderModel);
    }

    ChangeComments = (value) => {
        const { newOrderModel, RefreshOrder } = this.props
        newOrderModel.Comments = value;
        RefreshOrder(newOrderModel);
    }

    ChangeQuantityDelivery = async (index, item, event) => {
        const { showAlert, RefreshOrder, newOrderModel } = this.props;
        let newQuantity = event.nativeEvent.target.value;
        if (Number(newQuantity) > Number(item.OpenQty)) {
            newQuantity = Number(item.OpenQty);
            newOrderModel.Items[index].newQuantity = newQuantity;
            newOrderModel.Items[index].BatchNumbers = [];
            RefreshOrder(newOrderModel);
            showAlert({ type: 'warning', message: 'No puedes devolver mas unidades de las visibles', timeOut: 0 });
            return;
        } else {
            if (Number(newQuantity) <= Number(item.OpenQty) && Number(newQuantity) >= 0) {
                newOrderModel.Items[index].newQuantity = newQuantity;
                newOrderModel.Items[index].BatchNumbers = [];
                RefreshOrder(newOrderModel);
            }
        }
        

    }

    //#endregion
    //#region ########## AUXILIAR FUNCTIONS #############################################
    IsInteger(num) {
        if (num % 1 == 0) {
            return true
        } else {
            return false
        }
    }
    //#endregion



    render() {
        const { ShowDeliverModal, newOrderModel, SearchReserveInvoiceDoc, CloseRefundModal, checkbox, MakeReserveDelivery } = this.props

        return (
            <div>
                <div className="modal fade  modal-fullscreen" id="deliverModal" data-backdrop="false" data-keyboard="false" tabIndex="-1" aria-labelledby="deliverModalLabel" aria-hidden="true" >
                    <div className="modal-dialog" >
                        <div className="modal-content">
                            <div className="modal-header" style={{ background: "#343a40" }}>
                                <img src={require('../images/logocounter.png')} className="image" alt="COUNTER ONE" />
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} onClick={() => { CloseRefundModal(); ShowDeliverModal(); }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row ml-3 mt-3">
                                    <h4 className="modal-title ml-4" id="refundModalLabel">Entregas</h4>
                                </div>
                                <div className="container-fluid mt-3">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row m-3">
                                                <div className="col-4">
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text" id="basic-addon1"><strong>Buscar Fac. Reserva</strong></span>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Folio"
                                                            value={newOrderModel ? newOrderModel.U_FMB_FolioCounter : ''}
                                                            onChange={(event) => this.ChangeFolio(event.target.value)}
                                                            onKeyPress={(ev) => {
                                                                if (ev.key === 'Enter') {
                                                                    SearchReserveInvoiceDoc();
                                                                }
                                                            }}
                                                        />
                                                        <div className="input-group-append">
                                                            <button
                                                                type="button"
                                                                className="input-group-text"
                                                                style={{ backgroundColor: 'transparent', color: '#a1a9b1' }}
                                                                onClick={() => SearchReserveInvoiceDoc()}
                                                            >
                                                                <i className="fas fa-search" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-8'>

                                                </div>

                                                <div className="col-md-3">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Cliente</strong></span>
                                                        </div>
                                                        <input type="text"
                                                            className="form-control"
                                                            value={newOrderModel ? newOrderModel.CardCode : ''}
                                                            disabled />
                                                    </div>
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Nombre</strong></span>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={newOrderModel ? newOrderModel.CardName : ''}
                                                            disabled />
                                                    </div>
                                                </div>
                                                <div className='col-4 text-right'>

                                                    <button
                                                        type="button"
                                                        className="btn btn-primary ml-2"
                                                        onClick={() => MakeReserveDelivery()}
                                                    >Entregar</button>

                                                </div>
                                            </div>

                                            <div className="row m-3">
                                                <div className="col-6">
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text"><strong>Comentarios</strong></span>
                                                        </div>
                                                        <textarea
                                                            type="text"
                                                            className="form-control"
                                                            aria-label="With textarea"
                                                            value={newOrderModel ? newOrderModel.Comments : ''}
                                                            onChange={(event) => this.ChangeComments(event.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-3"> </div>
                                                <div className="col-3">
                                                </div>
                                            </div>

                                            <div className='card scrollTableRefound m-4' style={{ maxHeight: "560px" }}>
                                                <table className="table table-striped table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-center" scope="col">
                                                                #
                                                            </th>
                                                            <th className="text-center" scope="col">
                                                                <input
                                                                    type="checkbox"
                                                                    style={{ minWidth: '100%', width: '15px', height: '15px' }}
                                                                    id="CheckAll"
                                                                    onChange={(event) => checkbox.selectAll(event.target.checked)}
                                                                />
                                                            </th>
                                                            <th className="text-center" scope="col">
                                                                Código
                                                            </th>
                                                            <th className="col-6 text-center" scope="col">
                                                                Nombre
                                                            </th>
                                                            <th className=" text-center" scope="col">
                                                                Cantidad
                                                            </th>
                                                            <th className="text-center" scope="col">
                                                                Precio U.
                                                            </th>
                                                            <th className="text-center" scope="col">
                                                                Stock
                                                            </th>

                                                        </tr>

                                                    </thead>
                                                    <tbody>
                                                        {newOrderModel.Items && newOrderModel.Items.length > 0 &&
                                                            newOrderModel.Items.map((item, index) => {
                                                                return (
                                                                    <>
                                                                        <tr>
                                                                            <td className="text-center">
                                                                                <strong>{index + 1}</strong>
                                                                            </td>
                                                                            <td className="text-center">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    style={{ minWidth: '100%', width: '15px', height: '15px' }}
                                                                                    // disabled={parseInt(item.OpenQty) === 0 ? true : false}
                                                                                    checked={!!checkbox.data.get(index)}
                                                                                    onChange={() => checkbox.selectOne(index)}
                                                                                />
                                                                            </td>
                                                                            <td className="text-center">
                                                                                <strong>{item.ItemCode}</strong>
                                                                            </td>
                                                                            <td className="text-center">
                                                                                {item.ItemName}
                                                                            </td>
                                                                            <td className="text-center">
                                                                                {this.IsInteger(Number(item.OpenQty).toFixed(4)) ?
                                                                                    <strong>{parseInt(item.OpenQty)} /
                                                                                        <input
                                                                                            type="number"
                                                                                            min={0}
                                                                                            className="text-center input-cantidad"
                                                                                            max={parseInt(item.OpenQty)}
                                                                                            onChange={(event) => { this.ChangeQuantityDelivery(index, item, event) }}
                                                                                            value={item.newQuantity}
                                                                                        />
                                                                                    </strong>
                                                                                    :
                                                                                    <>
                                                                                        <strong>{Number(item.OpenQty ?? 0).toFixed(4)}{" / "}</strong>
                                                                                        <input
                                                                                            type="number"
                                                                                            className="text-center input-cantidad"
                                                                                            value={item.newQuantity ?? ''}
                                                                                            onChange={(event) => { this.ChangeQuantityDelivery(index, item, event) }}
                                                                                        />

                                                                                    </>

                                                                                }

                                                                            </td>
                                                                            <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(item.Price)}</td>
                                                                            <td className="text-center">{FORMAT_NUMBER.new(item.WhsStock)}</td>
                                                                        </tr>
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => { CloseRefundModal(); ShowDeliverModal(); }}>Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>






            </div >
        );
    }
}

export default DeliverModal;